import React from 'react';
import {Link} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {configStore} from 'app/store/global';
import {i18n_t} from 'app/i18n';
import {HeaderMenu} from 'site_version/com/HeaderMenu';
import {getLinkPath, isGuest, scrollToTop} from 'app/utils';
import {PageContent} from 'app/components/page_content';
import FooterPartnerList from 'site_version/common/FooterPartnerList';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import License from './License';

const Footer: React.FC = observer(() => {
    const showLicense = configStore.SHOW_LICENSE;

    return (
        <div id="footer" className="footer">
            <div className="footer__inner">
                <div className="footer__nav">
                    <nav className="footer-nav">
                        <Link to={getLinkPath('/esports')} className="footer-nav__link" onClick={scrollToTop}>
                            {i18n_t('menu_links.esport')}
                        </Link>

                        {HeaderMenu.map(item => <a key={item.section} className="footer-nav__link" href={getLinkPath(item.path)}>
                            {i18n_t(`menu_links.${item.section}`)}
                        </a>)}

                        <Link className="footer-nav__link" to={getLinkPath('/about')} onClick={scrollToTop}>
                            {i18n_t('menu_links.about')}
                        </Link>
                        <Link className="footer-nav__link" to={getLinkPath('/contacts')} onClick={scrollToTop}>
                            {i18n_t('menu_links.contacts')}
                        </Link>
                        <Link className="footer-nav__link" to={getLinkPath('/sitemap.html')} onClick={scrollToTop}>
                            {i18n_t('menu_links.sitemap')}
                        </Link>
                        <Link
                            className="footer-nav__link"
                            to={getLinkPath('/affiliates')}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {i18n_t('menu_links.affiliate')}
                        </Link>
                        <Link className="footer-nav__link" to={getLinkPath('/careers')} onClick={scrollToTop}>
                            {i18n_t('menu_links.careers')}
                        </Link>
                    </nav>
                </div>

                <div className="footer__text footer__text__top">
                    <div className="footer__plain-text">
                        <PageContent contentUrl="/" contentKey="footer_content" />
                    </div>
                </div>

                <div className="partner-list-license">
                    <FooterPartnerList />
                    <div className="footer__share-license">
                        <div className="license-list">
                            {showLicense && <License />}

                            <SpriteIcon name="#svg-eighteenplus" size={{height: 27, width: 27}} />
                        </div>
                    </div>
                </div>

                <div
                    className={`footer__text footer__text__bottom${
                        isGuest() ? ' padding_bottom' : ''
                    }`}
                >
                    <div className="footer__plain-text">
                        <PageContent contentUrl="/" contentKey="footer_content_license" />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Footer;
